module.exports = __webpack_public_path__ + "img/bc5fef399858301a46f66b4684dae1a3.svg";